import useTranslation from 'next-translate/useTranslation';
import { useCallback, useEffect } from 'react';
import SuccessIcon from '../icons/SuccessIcon';
const FeedBackScreen = ({
  onContinue
}: {
  onContinue: VoidFunction;
}) => {
  const {
    t
  } = useTranslation('satellite');
  const postRating = useCallback(() => {
    onContinue();
  }, [onContinue]);
  useEffect(() => {
    const timer = setTimeout(() => postRating(), 3000);
    return () => clearTimeout(timer);
  }, [postRating]);
  return <main className="flex flex-col items-center justify-center top-0 left-0 z-50 fixed bg-success-110 bg-white p-6 w-full h-screen overflow-hidden" data-sentry-component="FeedBackScreen" data-sentry-source-file="FeedBackScreen.tsx">
      <section className="flex flex-col items-center gap-4 text-white">
        <SuccessIcon fill="#ffffff" data-sentry-element="SuccessIcon" data-sentry-source-file="FeedBackScreen.tsx" />
        <p className="mt-4 mb-2">{t('farm_reg_success')}</p>
      </section>
    </main>;
};
export default FeedBackScreen;